import type { IconProps } from './types/types';

const TicketPendingOutlined = (props: IconProps) => {
  const { fill = 'currentColor', ...rest } = props;
  const svgProps = { fill, ...rest };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      {...svgProps}
    >
      <path d="M11.7738 14.9673C12.9397 14.9673 13.8848 14.0222 13.8848 12.8563C13.8848 11.6905 12.9397 10.7454 11.7738 10.7454C10.608 10.7454 9.66284 11.6905 9.66284 12.8563C9.66284 14.0222 10.608 14.9673 11.7738 14.9673Z" />
      <path d="M18.0005 14.9673C19.1663 14.9673 20.1115 14.0222 20.1115 12.8563C20.1115 11.6905 19.1663 10.7454 18.0005 10.7454C16.8346 10.7454 15.8895 11.6905 15.8895 12.8563C15.8895 14.0222 16.8346 14.9673 18.0005 14.9673Z" />
      <path d="M26.3384 12.8563C26.3384 14.0222 25.3933 14.9673 24.2274 14.9673C23.0616 14.9673 22.1165 14.0222 22.1165 12.8563C22.1165 11.6905 23.0616 10.7454 24.2274 10.7454C25.3933 10.7454 26.3384 11.6905 26.3384 12.8563Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.7863 1.9292H3.21491C2.50375 1.9292 1.9292 2.50375 1.9292 3.21491V32.7863C1.9292 33.4975 2.50375 34.0721 3.21491 34.0721H32.7863C33.4975 34.0721 34.0721 33.4975 34.0721 32.7863V3.21491C34.0721 2.50375 33.4975 1.9292 32.7863 1.9292ZM24 22.019H31.1792V4.82206H4.82206V22.019H12C12.0043 25.3292 14.6889 28.0112 18 28.0112C21.3111 28.0112 23.9958 25.3292 24 22.019Z"
      />
    </svg>
  );
};
export default TicketPendingOutlined;
